import React from 'react';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../util/reactIntl';

import { Modal, Button } from '../../components';
import BookingDatesOfferForm from './BookingDatesOfferForm/BookingDatesOfferForm';
import BookingTimeOfferForm from './BookingTimeOfferForm/BookingTimeOfferForm';

import css from './OfferModal.module.css';

/**
 * Offer modal
 *
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} props.id - The id of the modal
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {function} props.onCloseModal - The function to close the modal
 * @param {function} props.onManageDisableScrolling - The function to manage disable scrolling
 * @param {function} props.onSubmit - The function to submit offer
 * @returns {JSX.Element} Offer modal component
 */
const OfferModal = props => {
  const intl = useIntl();
  const {
    className,
    rootClassName,
    id,
    isOpen,
    onCloseModal,
    onManageDisableScrolling,
    onSubmit,
    offerFormProps,
    showBookingDatesForm,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      closeButtonMessage={intl.formatMessage({ id: 'OfferModal.close' })}
    >
      <p className={css.modalTitle}>
        <FormattedMessage id="OfferModal.title" />
      </p>
      <p className={css.modalMessage}>
        <FormattedMessage id="OfferModal.message" />
      </p>
      {showBookingDatesForm ? (
        <BookingDatesOfferForm {...offerFormProps} />
      ) : (
        <BookingTimeOfferForm {...offerFormProps} />
      )}
    </Modal>
  );
};

export default OfferModal;
